export default __webpack_public_path__ + "static/media/thumbnail_blog_12.ef3934f9.png";